module.exports = __webpack_public_path__ + "img/lv2.82199a31.png";